// ZarinpalPayment.jsx
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import BASE_URL from "../../config/config";

const ZarinpalPayment = ({ courseData, discount, csrfToken, onBack }) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const calculateFinalPrice = (price, discountPercent) => {
    const originalPrice = parseFloat(price) || 0;
    const discount = parseFloat(discountPercent) || 0;
    return originalPrice - (originalPrice * discount) / 100;
  };

  const validateMobile = (mobile) => {
    return /^09\d{9}$/.test(mobile);
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/[^0-9]/.test(value) || value.length > 11) return;
    setMobile(value);
    setErrors((prev) => ({
      ...prev,
      mobile:
        validateMobile(value) || value === "" ? "" : "شماره موبایل نامعتبر است",
    }));
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setErrors((prev) => ({
      ...prev,
      email: validateEmail(value) || value === "" ? "" : "ایمیل نامعتبر است",
    }));
  };

  const handlePayment = async () => {
    // اعتبارسنجی
    const newErrors = {};
    if (mobile && !validateMobile(mobile)) {
      newErrors.mobile = "شماره موبایل باید 11 رقم و با 09 شروع شود";
    }
    if (email && !validateEmail(email)) {
      newErrors.email = "فرمت ایمیل صحیح نیست";
    }

    // newErrors.general = "No Online gateway";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);
    try {
      const finalPrice = calculateFinalPrice(courseData.price, discount);

      // درخواست ایجاد تراکنش به بک‌اند
      const response = await fetch(`${BASE_URL}/zarinpal/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
        body: JSON.stringify({
          course_id: courseData.id,
          amount: finalPrice,
          description: `خرید  ${courseData.title}`,
          mobile: mobile || undefined,
          email: email || undefined,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "خطا در ایجاد درخواست پرداخت");
      }

      // هدایت به درگاه زرین‌پال
      if (data.gatewayUrl) {
        window.location.href = data.gatewayUrl;
      } else {
        throw new Error("لینک پرداخت دریافت نشد");
      }
    } catch (error) {
      alert("خطا: " + error.message);
      setIsLoading(false);
    }
  };

  return (
    <div className="zarinpal-payment">
      <button className="back-button" onClick={onBack}>
        ← بازگشت به انتخاب روش پرداخت
      </button>

      <div className="zarinpal-info">
        <div className="info-icon">🔒</div>
        <h3>پرداخت امن از طریق درگاه زرین‌پال</h3>
        <p>
          شما به درگاه پرداخت امن زرین‌پال هدایت خواهید شد. پس از پرداخت موفق،
          به‌طور خودکار به سایت بازگردانده می‌شوید.
        </p>
        <p>
          {errors.general && (
            <div className="error payment-notice-box">
              <div className="notice-header">
                <span className="notice-emoji">🎉</span>
                <strong>
                  برای تسریع در فرآیند ثبت‌نام، می‌توانید از طریق کارت به کارت
                  اقدام فرمایید.
                </strong>
              </div>
              <p className="notice-body">
                پس از واریز، دسترسی شما فوراً فعال می‌شود! ⚡
              </p>
              <div className="notice-footer">
                📞 پشتیبانی 24 ساعته:{" "}
                <span className="support-number">09331187978</span>
              </div>
            </div>
          )}
        </p>
      </div>

      <div className="form-group">
        <label htmlFor="mobile">شماره موبایل (اختیاری)</label>
        <input
          type="text"
          id="mobile"
          value={mobile}
          onChange={handleMobileChange}
          maxLength={11}
          className="form-control"
          placeholder="09123456789"
        />
        {errors.mobile && <div className="error">{errors.mobile}</div>}
        <small>برای دریافت پیامک وضعیت پرداخت</small>
      </div>

      <div className="form-group">
        <label htmlFor="email">ایمیل (اختیاری)</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={handleEmailChange}
          className="form-control"
          placeholder="example@email.com"
        />
        {errors.email && <div className="error">{errors.email}</div>}
        <small>برای دریافت رسید الکترونیکی</small>
      </div>

      <button
        onClick={handlePayment}
        disabled={isLoading}
        className="submit-button btn-pay zarinpal-btn"
      >
        {isLoading ? "در حال انتقال به درگاه..." : "🌐 پرداخت آنلاین"}
      </button>

      <div className="zarinpal-features">
        <div className="feature">✓ پرداخت امن با رمزنگاری SSL</div>
        <div className="feature">✓ پشتیبانی از تمام کارت‌های بانکی</div>
        <div className="feature">✓ تأیید فوری پرداخت</div>
      </div>
    </div>
  );
};

export default ZarinpalPayment;
